import { Platform } from 'react-native';
import { CoreScreens } from '@serviceos-rn/core';
import { TipRoutes } from './TipRoutes';
import { NormalTipScreenComponent } from '../Screens/TipScreen/NormalTipScreenComponent';
import { CompactTipScreenComponent } from '../Screens/TipScreen/CompactTipScreenComponent';
import { StatusScreenComponent } from '../Screens/StatusScreen/StatusScreenComponent';
import { TipModalScreenComponent } from '../Screens/TipModalScreen/TipModalScreenComponent';
const options = {
    animation: 'fade'
};
export const TipScreens = [
    ...CoreScreens,
    { name: TipRoutes.TipNormal, component: NormalTipScreenComponent, options },
    { name: TipRoutes.TipCompact, component: CompactTipScreenComponent, options },
    { name: TipRoutes.TipStatus, component: StatusScreenComponent, options },
];
export const TipModalScreen = {
    name: TipRoutes.TipModal,
    component: TipModalScreenComponent,
    options: {
        presentation: Platform.select({
            default: undefined,
            web: 'transparentModal'
        })
    }
};
